import { Collapse, Icon, ListItemIcon } from '@mui/material'
import List from '@mui/material/List'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemText from '@mui/material/ListItemText'
import ListSubheader from '@mui/material/ListSubheader'
import makeStyles from '@mui/styles/makeStyles'
import { buildHref } from 'lib/utils'
import { isActive } from 'pages/search'
import React, { useState } from 'react'
import FilterItem from './FilterItem'

const PATH = '/search'
const DEFAULT_ITEM_COUNT = 10

const useStyles = makeStyles((theme) => ({
  list: {
    backgroundColor: theme.palette.background.paper
  },
  header: {
    textTransform: 'uppercase '
  },
  moreLessButton: {
    color: theme.palette.primary.main,
    paddingLeft: '35px'
  },
  moreLessIcon: {
    color: theme.palette.primary.main,
    minWidth: 0
  },
  listItemSelected: {
    backgroundColor: 'transparent !important',
    '&::before': {
      content: '"\\e5ca"',
      fontFamily: 'Material Icons',
      fontWeight: 'bold',
      display: 'block',
      position: 'absolute',
      left: theme.spacing(2)
    },
    fontWeight: 500
  }
}))

function FilterItems ({ items, query, param }) {
  return (
    <>
      {items.map((item, key) => (
        <FilterItem
          name={item.name}
          key={item.key}
          selected={isActive(query, param, item.key)}
          href={buildHref(PATH, query, { [param]: item.key, page: null })}
        />
      ))}
    </>
  )
}

function ExpandButton ({ label, icon, handleExpandClick, classes }) {
  return (
    <ListItemButton classes={{ root: classes.moreLessButton }} onClick={handleExpandClick}>
      <ListItemIcon classes={{ root: classes.moreLessIcon }}>
        <Icon>{icon}</Icon>
      </ListItemIcon>
      <ListItemText disableTypography>
        {label}
      </ListItemText>
    </ListItemButton>
  )
}

export default function Filter ({ title, items, query, param }) {
  const classes = useStyles()
  const [expanded, setExpanded] = useState(false)

  if (items.length === 0) {
    return null
  }

  const handleExpandClick = () => {
    setExpanded(!expanded)
  }

  let initialItems
  let moreItems = []
  if (items.length > DEFAULT_ITEM_COUNT) {
    initialItems = items.slice(0, DEFAULT_ITEM_COUNT)
    moreItems = items.slice(DEFAULT_ITEM_COUNT)
  } else {
    initialItems = items
  }

  return (
    <List dense subheader={<ListSubheader className={classes.header}>{title}</ListSubheader>} className={classes.list}>
      <FilterItem
        name='Alle'
        href={buildHref(PATH, query, { [param]: null, page: null })}
        selected={isActive(query, param, 'all')}
      />

      <FilterItems items={initialItems} query={query} param={param} classes={classes} />

      {moreItems.length > 0 && !expanded &&
        <ExpandButton label='Weitere' icon='expand_more' handleExpandClick={handleExpandClick} classes={classes} />}

      {moreItems.length > 0 &&
        <Collapse in={expanded} timeout='auto' unmountOnExit>
          <FilterItems items={moreItems} query={query} param={param} classes={classes} />
          <ExpandButton label='Weniger anzeigen' icon='expand_less' handleExpandClick={handleExpandClick} classes={classes} />
        </Collapse>}
    </List>
  )
}
